import CreateCompany from './views/CreateCompany.vue'
import ListCompanies from './views/ListCompanies.vue'

import HomeLayout from '@/layouts/Home.vue'

export const companiesRoutes = [
  {
    path: '/companies',
    name: 'companies',
    component: ListCompanies,
    meta: {
      auth: true,
      layout: HomeLayout,
      requiredRoles: ['superadmin', 'admin'],
    },
  },
  {
    path: '/companies/add',
    name: 'companiesa/add',
    component: CreateCompany,
    meta: {
      auth: true,
      layout: HomeLayout,
      requiredRoles: ['superadmin', 'admin'],
    },
  },
]
